import { render, staticRenderFns } from "./ObtenerPlantillas.vue?vue&type=template&id=135eee82&"
import script from "./ObtenerPlantillas.vue?vue&type=script&lang=js&"
export * from "./ObtenerPlantillas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports